<!-- 登录页面 -->
<template>
    <div class="logonpage">

        <!-- 信息錄入頁面 -->
        <div class="subbox">

            <div class="title">
                <p style="font-weight: bold;font-size: 60px;">Welcome</p>
            </div>
            <div class="subtitle">
                <p style="color:#707070;">楚天惠家保增值服务系统</p>
            </div>

            <div class="input">
                <div class="inputtxt">
                    <div class="inputtitle">
                        <p>用户名</p>
                    </div>
                    <div class="inputbox">
                        <el-input v-model="username" placeholder="请输入账号..." maxlength="12"></el-input>
                    </div>
                </div>

                <div class="inputtxt">
                    <div class="inputtitle">
                        <p>用户密码</p>
                    </div>
                    <div class="inputbox">
                        <el-input v-model="password" placeholder="请输入密码..." show-password maxlength="16"></el-input>
                    </div>
                </div>


            </div>

            <div class="btn">
                <el-button type="primary" style="width: 100%;" @click="logingBtn()">登录</el-button>
            </div>
        </div>


        <!-- 版本信息 -->
        <div class="version">
            <el-link type="info" :style="{ fontSize: '12px', color: '#a0a0a0' }">驰尧增值家政</el-link>
            <el-link type="info" href="https://beian.miit.gov.cn/" :style="{ fontSize: '12px', color: '#a0a0a0' }">鄂ICP备2020019800号-2</el-link>
            <el-link type="info" :style="{ fontSize: '12px', color: '#a0a0a0' }">服务热线：027-85557717</el-link>
            <el-link type="info" :style="{ fontSize: '12px', color: '#a0a0a0' }">V {{ version }}</el-link>
        </div>

        <!-- 音频文件 -->
        <!-- <audio style="display: none;" ref="audio" src="https://downsc.chinaz.net/Files/DownLoad/sound1/202011/13594.mp3" preload="auto"></audio> -->
    </div>

</template>

<script>
import { Button, Input ,Link} from 'element-ui';


const packageInfo = require('../../package.json');
// import { PostMsg } from '../constant.js'

export default {
    components: {
        ElButton: Button,
        ElInput: Input,
        ElLink:Link
    },
    data() {
        return {
            username: '', // 用户名
            password: '', // 密码
            version: packageInfo.version
        }
    },
    methods: {
        // 登录按钮
        logingBtn() {
            // console.log(this.username,this.password);
            // this.$message.error('密码错误！');

            // this.$router.push('/contaniner');

            // 使用 ref 引用播放音频
            // this.$refs.audio.play();

            // console.log('xxxxxx');


            // PostMsg('/AdminMsg/login', {
            //     username: this.username,
            //     password: this.password
            // }).then(response => {
            //     console.log(response);
            // })

        }
    }

}
</script>

<style lang="less" scoped>
.logonpage {
    position: relative;
    // border: 1px solid red;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100vw;
    /* 宽度占满整个视口 */
    height: 100vh;
    /* 高度占满整个视口 */

    p {
        text-align: start;
    }


    .subbox {
        // width: 500px;
        // height: 500px;
        // border: 1px solid red;


        .title,
        .subtitle {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            font-size: 14px;
            // border: 1px solid red;
        }

        .input {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            margin-top: 10px;

            .inputtxt {
                margin-top: 20px;
                width: 100%;
            }

            .inputbox {
                margin-top: 10px;
            }


        }

        .btn {
            margin-top: 30px;
        }


    }

    .version {
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 12px;
        color: #a0a0a0;
        position: fixed;
        bottom: 40px;

        .el-link{
            font-size: 12px;
            color: #a0a0a0;
        }
    }

}
</style>
